import type { FromInterface } from '../../common/types';
import _schedule from './schedule';

export default {
  schedules: _schedule
} satisfies FromInterface;
